import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { stringify } from 'query-string'
import withHooks from 'cityads-v3/decorators/withHooks'
import { useThemeChanger } from 'cityads-v3/hooks/theme'
import i18n from 'cityads-v3/i18n';

import Dialog from 'cityads-v3/components/Dialog/Dialog';

import AuthIFrame from './AuthIFrame';

import config from 'cityads-v3/config';

import classNames from "./LoginDialog.scss";

@connect(
  state => ({
    language: state.language.language,
    isMobile: state.app.isMobile,
  })
)
@withHooks(props => ({
  ...props,
  themeChanger: useThemeChanger()
}))
@withTranslation(['main'], { i18n, wait: !!window })
export default class ForgotDialog extends Component {

  static propTypes = {
    onRequestClose: PropTypes.func,
    language      : PropTypes.string,
    isMobile      : PropTypes.bool,
  }

  getLoginDialogTabs() {
    const { t, language, themeChanger } = this.props

    const iframeSrc = `${config.AUTH_URL}/forgot?`
      + stringify({
        theme: 'material',
        lang: language,
        dark_mode: themeChanger.theme.palette.mode === 'dark' ? true : undefined
      })

    const tabs = [
      {
        value   : 'lost',
        label   : t('recovery'),
        children: <AuthIFrame src={iframeSrc} title={t('recovery')} className={classNames.loginFrame} />
      },
    ];

    return tabs;
  }

  render() {
    return (
      <Dialog
        open           = {true}
        onRequestClose = {this.props.onRequestClose}
        closeLink      = {this.props.closeLink}
        tab            = "lost"
        tabs           = {this.getLoginDialogTabs()}
        fullScreen     = {this.props.isMobile}
      />
    );
  }

}
